// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3QVoO","label":"LabeledBox_label__x8Y3L"};